import React from "react";
import { useAuth } from "../../auth/AuthProvider.jsx";
import { getRoles, roleLabel } from "../../auth/roles.js";

export default function UserProfile() {
    const { user } = useAuth();

    const displayName =
        user?.display_name ||
        user?.discord_username ||
        user?.email ||
        "User";

    const roles = getRoles(user);

    return (
        <div className="card">
            <h1>Profil</h1>

            <p className="muted">
                Hier werden später Discord-Profil, iRacing-Daten und RaceVision-Profilinformationen angezeigt.
            </p>

            <div style={{ marginTop: 18, display: "grid", gap: 10 }}>
                {user?.avatar_url && (
                    <img
                        src={user.avatar_url}
                        alt=""
                        style={{
                            width: 72,
                            height: 72,
                            borderRadius: "50%",
                            objectFit: "cover",
                        }}
                        referrerPolicy="no-referrer"
                    />
                )}

                <div>
                    <strong>Name:</strong> {displayName}
                </div>

                <div>
                    <strong>E-Mail/Sub:</strong> {user?.email || "nicht verfügbar"}
                </div>

                <div>
                    <strong>Discord ID:</strong> {user?.discord_id || "nicht verfügbar"}
                </div>

                <div>
                    <strong>Legacy-Rolle:</strong> {user?.role || "user"}
                </div>

                <div>
                    <strong>Rollen:</strong>{" "}
                    {roles.length ? roles.map(roleLabel).join(", ") : "keine Rollen gefunden"}
                </div>
            </div>
        </div>
    );
}